import { z } from 'zod/v4';

/**
 * Product kind sold by the payment form — mirrors the host app's `ProductType`
 * enum (`apps/websites/.../payment-form-widget.type.ts`). `default` is a plain
 * one-off payment; `eduCourse` ties the form to a SendPulse EDU course/tariff.
 */
export const productTypeSchema = z.enum(['default', 'eduCourse']);

/**
 * EDU-course product configuration — mirrors `EduCourseProductSettings`. Only
 * present once the user picks the `eduCourse` product type (otherwise
 * `productSettings` is `null`). `courseId`/`courseTariffId` are numeric ids
 * (`Id` is `number` in the host); `courseTariffId` may be absent for a course
 * with no paid tariff selected yet.
 */
export const eduCourseProductSettingsSchema = z.object({
    courseId: z.number(),
    courseTariffId: z.number().nullish(),
    isPaid: z.boolean().nullish(),
});

/**
 * Product settings union. Today only the EDU-course shape exists; the default
 * product carries `null`. Kept as a named alias so a future product kind can
 * widen this into a discriminated union.
 */
export const productSettingsSchema = eduCourseProductSettingsSchema;

export type ProductTypeLegacy = z.infer<typeof productTypeSchema>;
export type EduCourseProductSettingsLegacy = z.infer<typeof eduCourseProductSettingsSchema>;
export type ProductSettingsLegacy = z.infer<typeof productSettingsSchema>;
